import { FC, PropsWithChildren } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { useNewUiContext } from '@savgroup-front-common/core/components/NewUiProvider/NewUiProvider';
import { useGetFieldServiceTheme } from '@savgroup-front-common/core/theme/Theme';

export const ThemeProvider: FC<PropsWithChildren<any>> = ({ children }) => {
  const { isDarkModeEnabled } = useNewUiContext();

  const theme = useGetFieldServiceTheme({}, isDarkModeEnabled);

  return <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>;
};
